import {useWatch} from 'react-hook-form'

import {useFieldConfigurationContext} from '../../configuration/useConfigurationContext'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'

import {TextFieldTypes} from './types'

export const useTextField = (fieldName: TextFieldTypes) => {
  const {control, setValue, formState: {defaultValues}} = useOrderProcessFormContext()
  const fieldConfiguration = useFieldConfigurationContext(fieldName)

  const fieldValue = useWatch({
    control,
    name: fieldName
  })
  const defaultFieldValue = defaultValues?.[fieldName];

  const setFieldValue = (newValue: string) => {
    setValue(fieldName, newValue, {shouldValidate: true, shouldDirty: true, shouldTouch: true})
  }

  return {
    fieldValue,
    defaultFieldValue,
    setFieldValue,
    fieldConfiguration
  }
}
